<template>
  <section class="price">
    <div class="container">
      <a-typography-title :level="1">
        软硬一体机
      </a-typography-title>
      <div class="box">
        <a-tabs :tabPosition="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?'left':'top'">
          <a-tab-pane v-for="(item,index) in expand.list" :key="item.title" :tab="item.title">
            <a-row>
              <a-col :xs="24" :md="24" :lg="24">
                <div class="item" :class="`box_${index+1} ${$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?'item_large':'item_small'}`">
                  <div class=" item_table">
                    <a-table :dataSource="item.dataSource" :columns="item.columns" size="small" :pagination="false" />
                  </div>
                  <div class="item_image">
                    <a-image :src="item.image" />
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3" @click="clickToAidigitalHuman()" style="width:135px !important">
          免费试用(SaaS)
        </a-button>
        <a-button type="link" class="button_n_3" @click="$FN.JumpDownloadApk()" style="width:135px !important">
          下载客户端
          <AndroidOutlined />
        </a-button>
        <a-button class="button_n_2"  type="link" 
                 @click="$Store.Page().openModal('modalFormCollection','productAidigitalHuman')">
         联系我们
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from "@interface/public";
import Image_1 from "@resource/image/page/productAidigitalHuman/1.jpeg";
import Image_2 from "@resource/image/page/productAidigitalHuman/2.png";
import Image_3 from "@resource/image/page/productAidigitalHuman/3.png";
import Image_4 from "@resource/image/page/productAidigitalHuman/4.jpeg";
import { AndroidOutlined } from '@ant-design/icons-vue';

export default {
  name: "product_price",
  components: { AndroidOutlined },
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            dataSource: [
              {
                key: "1",
                model: "43英寸",
                resolution: "1920*1080",
                power: "65w",
                material: "钢化玻璃",
                system: "Android",
                size: "1737.4*583.9*94mm",
              },
              {
                key: "2",
                model: "49英寸",
                resolution: "1920*1080",
                power: "75w",
                material: "钢化玻璃",
                system: "Android",
                size: "1829*660.5*94mm",
              },
              {
                key: "3",
                model: "55英寸",
                resolution: "1920*1080",
                power: "90w",
                material: "钢化玻璃",
                system: "Android",
                size: "1889*734.5*94mm",
              },
              {
                key: "4",
                model: "65英寸",
                resolution: "1920*1080",
                power: "95w",
                material: "钢化玻璃",
                system: "Android",
                size: "1978*858.5*94mm",
              },
            ],
            columns: [
              {
                title: "型号",
                dataIndex: "model",
                key: "model",
              },
              {
                title: "分辨率",
                dataIndex: "resolution",
                key: "resolution",
              },
              {
                title: "操作系统",
                dataIndex: "system",
                key: "system",
              },
              {
                title: "机身尺寸",
                dataIndex: "size",
                key: "size",
              },
              {
                title: "屏幕保护材料",
                dataIndex: "material",
                key: "material",
              },
              {
                title: "功耗",
                dataIndex: "power",
                key: "power",
              },
            ],
            image: Image_1,
            title: "立柜款",
          },
          {
            dataSource: [
              {
                key: "1",
                model: "69英寸", // 修改为69寸
                resolution: "3840(H)x148B(V)(4K)", // 修改为4K分辨率
                material: "4mm物理钢化", // 屏幕保护材料
                system: "Android", // 操作系统
                size: "1822*760*500mm", // 机身尺寸
              },
            ],
            columns: [
              {
                title: "型号",
                dataIndex: "model",
                key: "model",
              },
              {
                title: "分辨率",
                dataIndex: "resolution",
                key: "resolution",
              },
              {
                title: "操作系统",
                dataIndex: "system",
                key: "system",
              },
              {
                title: "机身尺寸",
                dataIndex: "size",
                key: "size",
              },
              {
                title: "屏幕保护材料",
                dataIndex: "material",
                key: "material",
              },
            ],
            image: Image_4, // 图片根据实际需要添加
            title: "立柜式全面屏", // 标题
          },
          {
            dataSource: [
              {
                key: "1",
                cpu: "八核 4*RAM Cortex A73@2.0GHZ 4*RAM Cortex A53@2.0GHZ",
                ram: "4/6GB",
                storage: "64/128GB",
                os: "Android 12",
                display: "21.5英寸",
                ratio: "16:9",
                resolution: "1080*1920 IPS",
              },
            ],
            columns: [
              {
                title: "型号",
                dataIndex: "cpu",
                width: "150px",
                key: "cpu",
              },
              {
                title: "分辨率",
                dataIndex: "resolution",
                key: "resolution",
              },
              {
                title: "操作系统",
                dataIndex: "os",
                key: "os",
              },
              {
                title: "机身尺寸",
                dataIndex: "display",
                key: "display",
              },
              {
                title: "屏幕比例",
                dataIndex: "ratio",
                key: "ratio",
              },
              {
                title: "RAM",
                dataIndex: "ram",
                key: "ram",
              },
              {
                title: "内存",
                dataIndex: "storage",
                key: "storage",
              },
            ],
            image: Image_2,
            title: "移动屏",
          },
          {
            dataSource: [
              {
                key: "1",
                model: "横款",
                panelSize: "10.1英寸（16:9）",
                resolution: "1280*800（v）",
                power: "60w",
                voltage: "DC12V5A",
                camera: "800W",
                size: "297*224.5*100mm",
              },
              {
                key: "2",
                model: "竖款",
                panelSize: "21.5英寸 (16:9)",
                resolution: "1920*1080（v）",
                power: "60w",
                voltage: "AC220V 50/60Hz",
                camera: "830W",
                size: "646*374*250mm",
              },
              {
                key: "3",
                model: "(红外系列)",
                panelSize: "86英寸 (16: 9)",
                resolution: "3840(H)x2160(V)(4K)",
                power: "250w",
                voltage: "AC220V 50/60Hz",
                camera: "800W",
                size: "646*374*250mm",
              },
            ],
            columns: [
              {
                title: "型号",
                dataIndex: "model",
                key: "model",
              },
              {
                title: "分辨率",
                dataIndex: "resolution",
                key: "resolution",
              },
              {
                title: "整体尺寸",
                dataIndex: "size",
                key: "size",
              },
              {
                title: "面板尺寸",
                dataIndex: "panelSize",
                key: "panelSize",
              },

              {
                title: "功率",
                dataIndex: "power",
                key: "power",
              },
              {
                title: "输入电压",
                dataIndex: "voltage",
                key: "voltage",
              },
              {
                title: "摄像头",
                dataIndex: "camera",
                key: "camera",
              },
            ],
            image: Image_3,
            title: "全息透明屏",
          },
        ],
      },
    };
  },
  methods: {
    /**
     * 点击去AI数字人
     */
    clickToAidigitalHuman(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open("https://aiavatars-monn34rc.apps.galaxy-future.com/");
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@imagePublic: "@{src_image}page/public/";

.price {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg("@{imagePublic}bg_1.jpg");
  background-size: cover;

  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @font_7, @color_13, @font_7);
}

.ant-row {
  margin: @margin_mo 0 0;
}

table {
  border-color: blue;
}
.box {
  @wh: 80px;
  @h: 50px;
  @style: fade(@color_white, 50), @color_white;
  position: relative;
  width: 100%;
  min-height: 215px + @h;
  padding: @padding @padding;
  margin: 24px 0;
  .gradientLinear(0deg, @style);
  border: 2px solid @color_14;
  border-radius: 8px;
}
.item {
  @wh: 80px;
  @h: 50px;
  @style: fade(@color_white, 50), @color_white;
  position: relative;
  width: 100%;
  min-height: 215px + @h;
  .gradientLinear(0deg, @style);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: auto;
  &_small {
    flex-wrap: wrap;
    .item_table {
      flex: none;
      width: max-content;
    }
    :deep(.ant-image) {
      border-radius: 8px;
      margin-top: 12px;
    }
    :deep(.ant-image-img) {
      border-radius: 8px;
    }
  }
  &_table {
    height: 100%;
    width: 100%;
    align-self: flex-start;
    margin-right: 24px;
  }
  &_image {
    flex: none;
  }
  :deep(.ant-image) {
    border-radius: 8px;
    height: 280px;
    width: max-content;
  }
  :deep(.ant-image-img) {
    border-radius: 8px;
    height: 280px;
    width: max-content;
  }
  :deep(.ant-image-mask) {
    border-radius: 8px;
  }

  h5.ant-typography {
    margin: 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }

  .ant-row {
    margin: @margin_mo 0 0;

    &:nth-child(2) {
      margin: @margin 0 0;
    }

    .ant-col {
      &:nth-child(1) {
        .font(left, @text, @color_13, @text);
      }

      &:nth-child(2) {
        .font(right, @text, @color_13, @text);
      }
    }
  }

  .money {
    display: flex;
    align-items: center;
    justify-content: center;
    height: @h;
    .position(bottom);
    .font(center, @text_big, @color_12, @text_big, true);

    > span {
      position: relative;

      span {
        line-height: @font_8;
        font-size: @font_8;

        &.left {
          .position(absolute, auto, auto, 2px, -20px);
        }

        &.right {
          .position(absolute, auto, -30px, 2px, auto);
        }
      }
    }
  }
}

@media screen and (min-width: @grid_xl) {
  .ant-row {
    .ant-col {
      flex: 1;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .price {
    .container {
      padding: @space_mo 0;
    }
  }

  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }

  .ant-row {
    margin: @margin_mo 0 0;
  }

  .item {
    min-height: auto;

    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }

    .ant-row {
      .ant-col {
        &:nth-child(1) {
          .font(left, @font_7, @color_12, @font_7);
        }

        &:nth-child(2) {
          .font(right, @font_7, @color_12, @font_7);
        }
      }
    }
  }
}
</style>